app.service('brandView', function (autocompleteInfo, pageConfig ) {

	function init() {
		autocompleteInfo.logResult('brand', pageConfig.getData('brand'));
	}
	return {
		init
	};
});
